<template>
  <div class="container">
    <div class="wrap z-flex">
      <myLeft></myLeft>
      <div class="my-r">
        <myTop></myTop>
        <div class="box-con my-box">
          <myNav :activeMynav="'ps'"></myNav>
          <div class="bd">
              <div class="my-list">
                <el-table :data="list" style="width: 100%">
                  <el-table-column prop="orderNum" label="订单号"></el-table-column>
                  <el-table-column prop="title" label="修图包"></el-table-column>
                  <el-table-column prop="imgs" label="图片" width="200px">
                    <template slot-scope="scope">
                      <div class="z-flex">
                        <div class="img-item" v-for="(item,index) in scope.row.imgs.slice(0,4)" :key="index">
                          <el-image class="img" fit="cover" :src="item + `?x-oss-process=image/resize,m_lfit,h_200,w_200`"></el-image>
                          <div class="mask z-flex z-flex-center" v-if="index == 3">+{{scope.row.imgs.length - 3}}</div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="psNum" label="修图张数" width="80px"></el-table-column>
                  <el-table-column prop="psCoin" label="修图币余额" width="90px"></el-table-column>
                  <el-table-column prop="orderTime" label="购买日期" width="100px"></el-table-column>
<!--                  <el-table-column prop="completeTime" label="完成时间" width="100px">-->
<!--                    <template slot-scope="scope">-->
<!--                      <span v-if="scope.row.completeTime">{{scope.row.completeTime}}</span>-->
<!--                      <span v-if="scope.row.sta==0">待修图</span>-->
<!--                      <span v-if="scope.row.sta==1">修图中</span>-->
<!--                      <span v-if="scope.row.sta==2">待确认</span>-->
<!--                      <span v-if="scope.row.sta==3">已完成</span>-->
<!--                      <span v-if="scope.row.sta==4">已取消</span>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                  <el-table-column label="操作" width="80px">
                    <template slot-scope="scope">
                      <el-button class="edit-btn" size="mini" type="text" v-if="scope.row.psNum!=scope.row.psCoin" @click="checkPsOrder(scope.$index, scope.row)">查看</el-button>
                      <el-button class="edit-btn" size="mini" type="text" v-if="scope.row.psNum==scope.row.psCoin" @click="toUrl(`/ps/submit`)">修图</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <!-- 分页 -->
                <el-pagination 
                  class="pagination" 
                  background 
                  layout="prev, pager, next" 
                  :total="totalNum"
                  :page-size="pageSize"
                  hide-on-single-page
                  @current-change="changePage"
                >
                </el-pagination>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myLeft from "@/components/my/myLeft";
import myTop from "@/components/my/myTop";
import myNav from "@/components/my/myNav";
export default {
  components: {
    myLeft,
    myTop,
    myNav,
  },
  data() {
    return {
      curPage:1,
      totalNum:0,
      pageSize:20,
      list: [
        // {
        //   orderNum:'12365455666555',
        //   title:'曾瑞棉修图包100张',
        //   imgs:[
        //     'https://qsh-imgstore.oss-cn-hangzhou.aliyuncs.com/uploads/thumb/d58/c6a/d58c6a4cec913d5f9493bece32561c6d.jpg',
        //     'https://qsh-imgstore.oss-cn-hangzhou.aliyuncs.com/uploads/thumb/d58/c6a/d58c6a4cec913d5f9493bece32561c6d.jpg',
        //     'https://qsh-imgstore.oss-cn-hangzhou.aliyuncs.com/uploads/thumb/d58/c6a/d58c6a4cec913d5f9493bece32561c6d.jpg',
        //     'https://qsh-imgstore.oss-cn-hangzhou.aliyuncs.com/uploads/thumb/d58/c6a/d58c6a4cec913d5f9493bece32561c6d.jpg',
        //     'https://qsh-imgstore.oss-cn-hangzhou.aliyuncs.com/uploads/thumb/d58/c6a/d58c6a4cec913d5f9493bece32561c6d.jpg',
        //   ],
        //   psNum:22,
        //   psCoin:666,
        //   orderTime:'2022-09-15 12:00:00',
        //   completeTime:'',
        //   sta:0,//等待接单
        // }
      ],
    };
  },
  computed: {
    
  },
  mounted() {
    this.getRows();
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    //分页
    changePage(e){
      this.curPage = e;
      this.getRows();
    },
    checkPsOrder(index,item){
      this.toUrl(`/my/psCheckOrder?userpsId=${item.id}`)
    },
    downloadImg(index,item){

    },
    //获取列表数据
    getRows() {
      const loading = this.$loading({target:'.my-list',});
      let params = {offset: (this.curPage - 1)  * this.pageSize, length: this.pageSize};
      this.$axios.api.myPsList(params, (res) => {
        if (res.code == 200) {
          this.totalNum = res.data.total;
          this.list = res.data.list;
          loading.close();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap{
  align-items: flex-start;
}
.el-button{
  i{
    margin:0 5px 0 0;
  }
}
.my-box{
  .bd{
    padding: 20px;
    .my-list{
      ::v-deep .el-table{
        th{
          background:#f5f5f5;
        }
        .img-item{
          width:40px;
          height:40px;
          margin-right: 5px;
          position: relative;
          .img{
            width:100%;
            height:100%;
          }
          .mask{
            width:100%;
            height:100%;
            color: #fff;
            background: rgba(0,0,0,.6);
            position: absolute;
            left: 0;
            top: 0;
          }
        }
      }
    }
  }
}
</style>
